import React, { useState } from 'react'
import loader from "../../assets/loader.webp";

const Online = () => {
    const [loading] = useState(true);

  if (loading){
    return (
        <div className="w-full h-full flex justify-center items-center">
          <img src={loader} alt="loading..." className="w-12" />
        </div>
    );
  }
  return (
    <div>Online</div>
  )
}

export default Online